import { type FanShopProductVariant, queryClient } from '@capsicum/common';
import { usePartnerFiltered } from '@capsicum/socios-core';
import { useMemo } from 'react';

import { useProductsQueries, UseProductsQueryKeyBuilder } from '../data-access/queries/useProductsQueries';

type UseProductsProps = {
	categoryIds?: Array<string>;
	partnerIds?: Array<string>;
};

export const useProducts = ({ categoryIds, partnerIds }: UseProductsProps) => {
	const { selectedPartners } = usePartnerFiltered();

	const {
		data,
		fetchNextPage,
		hasNextPage,
		isFetched,
		isFetching,
		isFetchingNextPage,
		isLoading: loadingProducts,
		refetch: refetchProducts
	} = useProductsQueries(partnerIds ?? selectedPartners, categoryIds);

	const products: Array<FanShopProductVariant> = useMemo(
		() =>
			(data &&
				data?.pages.flatMap(page => {
					return page?.data || [];
				})) ??
			[],
		[data]
	);

	return {
		fetchNextPage,
		hasNextPage,
		isFetched,
		isFetching,
		isFetchingNextPage,
		loadingProducts,
		products,
		refetchProducts,
		remove: () =>
			queryClient.removeQueries({ queryKey: UseProductsQueryKeyBuilder(selectedPartners, categoryIds, 10) })
	};
};
